import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getCoinFlipGameReportService,
  getCrashGameReportService,
  getCrossGameReportService,
  getDiceGameReportService,
  getGongaMineGameReportService,
  getHiloGameReportService,
  getKenoGameReportService,
  getPyramidPlinkoGameReportService,
  getTowerGameReportService
} from 'network/services/game.service'
import { DEFAULT_GAME_ID } from 'utils/constants/index'

export const fetchCrashGameReport = createAsyncThunk(
  'fetch/crashGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCrashGameReportService({ gameId: DEFAULT_GAME_ID.CRASH, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchKenoGameReport = createAsyncThunk(
  'fetch/kenoGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getKenoGameReportService({ gameId: DEFAULT_GAME_ID.KENO, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchDiceGameReport = createAsyncThunk(
  'fetch/diceGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getDiceGameReportService({ gameId: DEFAULT_GAME_ID.DICE, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchHiloGameReport = createAsyncThunk(
  'fetch/hiloGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getHiloGameReportService({ gameId: DEFAULT_GAME_ID.HILO, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCoinFlipGameReport = createAsyncThunk(
  'fetch/coinflipGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCoinFlipGameReportService({ gameId: DEFAULT_GAME_ID.COIN_FLIP, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchPyramidPlinkoGameReport = createAsyncThunk(
  'fetch/pyramidPlinkoGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getPyramidPlinkoGameReportService({ gameId: DEFAULT_GAME_ID.PYRAMID_PLINKO, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchGongaMineGameReport = createAsyncThunk(
  'fetch/gongaMineGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getGongaMineGameReportService({ gameId: DEFAULT_GAME_ID.GONGA_MINE, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchTowerGameReport = createAsyncThunk(
  'fetch/towerGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getTowerGameReportService({ gameId: DEFAULT_GAME_ID.TOWER, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCrossGameReport = createAsyncThunk(
  'fetch/crossGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCrossGameReportService({ gameId: DEFAULT_GAME_ID.CROSS, ...data })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
